import React from 'react';
import { useLocation } from 'react-router-dom';
import { useRecoilValue } from 'recoil';
import { Current_User } from '@recoil/recoil';
import { ROLE_CONST } from '@constants/commonConstants';
import PursuitLeaderForecast from '@pages/forecast/pursuitLeaderForecast';
import GcspForecast from '@pages/forecast/gcspForecast';
import PursuitLeadePastForecast from '@pages/forecast/pastForecast/pastForecast';
import GcspPastForecast from '@pages/forecast/pastForecast/gcspPastForecast';
import MslForecast from '@pages/forecast/mslForecast';

const Forecast = () => {
  const location = useLocation();
  const data = location.state;
  const currentUser = useRecoilValue(Current_User);
  if (data !== null) {
    return (
      <>
        {' '}
        {currentUser !== null && currentUser.role === ROLE_CONST.PL ? (
          <PursuitLeadePastForecast data={data}></PursuitLeadePastForecast>
        ) : null}
        {currentUser !== null &&
        (currentUser.role === ROLE_CONST.GCSP || currentUser.role === ROLE_CONST.GCSP_READ_ONLY) ? (
          <GcspPastForecast data={data}></GcspPastForecast>
        ) : null}
      </>
    );
  } else {
    return (
      <>
        {' '}
        {currentUser !== null && currentUser.role === ROLE_CONST.PL ? (
          <PursuitLeaderForecast></PursuitLeaderForecast>
        ) : null}
        {currentUser !== null &&
        (currentUser.role === ROLE_CONST.GCSP || currentUser.role === ROLE_CONST.GCSP_READ_ONLY) ? (
          <GcspForecast></GcspForecast>
        ) : null}
        {currentUser !== null &&
        (currentUser.role === ROLE_CONST.MSL ||
          currentUser.role === ROLE_CONST.MSL_DELEGATE ||
          currentUser.role === ROLE_CONST.MSL_READ_ONLY) ? (
          <MslForecast></MslForecast>
        ) : null}
      </>
    );
  }
};

export default Forecast;
